/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Point,
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './Point';

/**
 * 
 * @export
 * @interface VisitBoundaryWithId
 */
export interface VisitBoundaryWithId {
    /**
     * 
     * @type {number}
     * @memberof VisitBoundaryWithId
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VisitBoundaryWithId
     */
    name: string;
    /**
     * 
     * @type {Array<Point>}
     * @memberof VisitBoundaryWithId
     */
    points: Array<Point>;
}

export function VisitBoundaryWithIdFromJSON(json: any): VisitBoundaryWithId {
    return VisitBoundaryWithIdFromJSONTyped(json, false);
}

export function VisitBoundaryWithIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitBoundaryWithId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'points': ((json['points'] as Array<any>).map(PointFromJSON)),
    };
}

export function VisitBoundaryWithIdToJSON(value?: VisitBoundaryWithId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'points': ((value.points as Array<any>).map(PointToJSON)),
    };
}

